// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
  Container,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// import { useNavigate } from "react-router-dom";
import { useAuthUser } from "react-auth-kit";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";
import QRCode from "react-qr-code";

function Orders() {
  const pageTitle = "Sales History";
  usePageTitle(pageTitle);

  const auth = useAuthUser();
  const accountInfo = auth();

  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [orders, setOrders] = useState([]);
  const [openDispenseDialog, setOpenDispenseDialog] = useState(false);
  const [order, setorder] = useState(null);

  const [openCopySnackBar, setOpenSnackBar] = useState(false);
  async function copy(stringtext) {
    console.log(stringtext);
    try {
      await navigator.clipboard.writeText(stringtext);
      setOpenSnackBar(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  const tableColumns = [
    { Header: "Order", accessor: "view", align: "left" },
    { Header: "Customer", accessor: "customer", align: "left" },
    { Header: "Campaign", accessor: "campaign", align: "left" },
    { Header: "Brand", accessor: "brand", align: "left" },
    { Header: "Date", accessor: "created", align: "left" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        view: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="contained"
              color="info"
              iconOnly
              circular
              onClick={() => {
                setorder(row);
                setOpenDispenseDialog(true);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                visibility
              </Icon>
            </MDButton>
          </MDBox>
        ),
        brand: row.account,
        campaign: row.campaign,
        customer: row.customer,
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/orders.json")
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRateRows(result.data.data.orders);
            setOrders(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {order ? (
        <Dialog open={openDispenseDialog} fullWidth maxWidth="sm">
          <DialogContent>
            <Container align="center">
              <MDTypography align="center">
                <MDBox>
                  <MDBox mt={1} mb={2}>
                    <MDTypography variant="h6" fontWeight="medium">
                      {order.campaign}
                    </MDTypography>
                  </MDBox>
                  <QRCode value={order.receipt} size={180} />
                  <MDTypography variant="h6" fontWeight="light" mt={1} mb={1}>
                    <b>Order ID</b>
                    <br />
                    {order.reference}&nbsp;&nbsp;
                    <MDButton
                      iconOnly
                      onClick={() => {
                        copy(order.reference);
                      }}
                      color="info"
                      variant="outlined"
                      size="small"
                    >
                      <Icon>content_copy</Icon>
                    </MDButton>
                  </MDTypography>
                  {order.items.map((orderItem) => (
                    <MDBox mt={1} align="left">
                      <Divider />
                      <MDTypography variant="h6" fontWeight="light">
                        {orderItem.product}
                      </MDTypography>
                      {orderItem.objects.map((object) => (
                        <>
                          {object.map((record) => (
                            <MDBox
                              mt={1}
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <MDBox>
                                <MDTypography variant="caption" fontWeight="light">
                                  <b>{record.display_name}</b>
                                  <br />
                                  {record.value}
                                </MDTypography>
                              </MDBox>
                              <MDBox>
                                <MDButton
                                  iconOnly
                                  onClick={() => {
                                    copy(record.value);
                                  }}
                                  color="info"
                                  variant="outlined"
                                  size="small"
                                >
                                  <Icon>content_copy</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          ))}
                        </>
                      ))}
                    </MDBox>
                  ))}
                </MDBox>
                <Snackbar
                  autoHideDuration={5000}
                  onClose={() => setOpenSnackBar(false)}
                  open={openCopySnackBar}
                >
                  <Alert severity="success" sx={{ width: "100%" }}>
                    Copied
                  </Alert>
                </Snackbar>
              </MDTypography>
            </Container>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenDispenseDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon>close</Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox
                        pt={2}
                        px={2}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDTypography variant="h6" fontWeight="medium">
                          History
                        </MDTypography>
                        <MDBox alignContents="center">
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            <a
                              href={`${AppConfig.api_base_url}agents/campaign/reports/${accountInfo.reference}.json`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <Icon sx={{ fontWeight: "bold" }}>download</Icon> &nbsp;Report
                            </a>
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: tableColumns, rows: orders }}
                          isSorted
                          entriesPerPage={false}
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Orders;
